addEventListener("load", async () => {

  var bodyContainer = document.querySelector("body");

  var GAHelpers = (() => {
    return {
      /**
       * Get cart json
       * @returns cart
       */
      fetchCart: async () => {
        return await fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            return cart;
          });
      },
      /** */
      normalizeProduct: (product, variant, index = null) => {
        return {
          item_id: variant.id,
          item_name: product.title,
          currency: "CLP",
          index: index,
          item_brand: product.vendor,
          item_category: product.product_type,
          item_category1: product.vendor,
          // item_category2: product.product_type,
          item_variant: variant.title,
          price: variant.price,
          quantity: 1

        }
      },
      /**
       * 
       * @param {*} product 
       * @param {*} variant 
       * @param {*} index 
       * @returns 
       */
      normalizeProductByVariant: (product, variant, index = null) => {
        return {
          currency: "CLP",
          value: variant?.price,
          items: [GAHelpers.normalizeProduct(product, variant, index)]
        }
      },
      /**
       * 
       * @param {*} handle 
       * @param {*} variantId 
       * @param {*} index 
       */
      handleProductDataByHandle: async (handle, variantId, index = null, multiple = false) => {
        return await fetch(`/products/${handle}.json`)
          .then(response => response.json())
          .then(({ product }) => {
            const variant = product.variants.filter(x => x.id == variantId)[0];
            if (multiple) {
              return GAHelpers.normalizeProduct(product, variant, index)
            }
            return GAHelpers.normalizeProductByVariant(product, variant, index);
          })
      },
      dispatchDatalayer: (eventName, eventParams) => {
        gtag("event", eventName, eventParams);
      },
      /**
       * 
       * @param {*} target 
       * @returns 
       */
      handleCartEvent: async (target) => {
        let eventType;
        if (target.classList.contains("cart__drawer-checkout")) {
          eventType = "view_cart";
        } else {
          return;
        }

        const { items, total_price } = await GAHelpers.fetchCart();
        const productsInCart = items.map((item, index) => {
          const cartItems = GAHelpers.normalizeProductByVariant(item, item, index)["items"][0];
          return {
            ...cartItems,
            price: cartItems.price / 100
          }
        });
        const data = {
          currency: "CLP",
          value: eventType === "view_cart" ? total_price / 100 : total_price,
          items: productsInCart
        };
        GAHelpers.dispatchDatalayer(eventType, data);
      },
      /**
       * 
       * @param {*} parent 
       */
      handlePromotionSelect: (parent, viewPromotion = false) => {
        const creativeName = parent?.getAttribute("data-layercreative");
        const creativeSlot = parent?.getAttribute("data-index");
        const promotionId = parent?.getAttribute("data-layer-position");
        const promotionName = parent?.getAttribute("data-layer-name");
        let eventName = "select_promotion"
        if (viewPromotion) {
          eventName = "view_promotion"
        }

        const eventData = {
          creativeName,
          creativeSlot,
          promotionId,
          promotionName
        };

        Shopify.analytics.publish(eventName, eventData);
        if (eventName === "select_promotion") {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                promotionName: promotionName,
                promotionId: promotionId
              }
            })
          })
            .then(response => response.json())
            .catch(error => {
              console.error('Error al actualizar el carrito:', error);
            });
        }
      },
      /**
       * 
       * @param {*} parent 
       */
      handleSelectContent: (parent) => {
        const contentType = parent?.getAttribute("data-content-type");
        const itemName = parent?.getAttribute("data-item-name");
        Shopify.analytics.publish("select_content", { content_type: contentType, itemName });
      },
      /**
       * 
       * @param {*} parent 
       */
      handleSelectItem: async (parent) => {
        const handle = parent.getAttribute("data-handle");
        const variantId = parent.getAttribute("data-variant-id");
        const index = parent.getAttribute("data-index");

        const product = await Shopify.analytics.publish('handleProductDataByHandle', {
          handle: handle,
          variantId: parseInt(variantId),
          index: index
        });

        if (product) {
          const eventData = {
            item_name: product.name,
            item_id: product.id,
            item_variant: product.variant,
            index: index,
          };
          Shopify.analytics.publish("select_item", eventData);
        }
      }
    }
  })();


  bodyContainer.onclick = async ({ target }) => {
    /**
     * Event remove_from_cart
     */
    if (target.classList.contains("cart-remove-button") || target.classList.contains("btn-remove-product-mini-cart")) {
      const handle = target.getAttribute("data-variant-handle");
      const variantId = target.getAttribute("data-variant-id");
      const index = target.getAttribute("data-index");
      try {
        const result = await Shopify.analytics.publish('handleProductDataByHandle', {
          handle: handle,
          variantId: parseInt(variantId),
          index: index
        });
        if (result) {
          Shopify.analytics.publish("remove_from_cart", result);
        }
      } catch (error) {
        console.log(error);
      }
    }
    /**
     * Event view_cart & begin_checkout
     */
    if (target.classList.contains("cart__drawer-checkout") || target.classList.contains("cart__begin-checkout")) {
      GAHelpers.handleCartEvent(target)
    }
    /**
     * Events Home
     */


    /**
     * Slides - Banner
    */


    /**
     * Block: banner__info
     */
    if (target.classList.contains("banner__info-url")) {
      SGAHelpers.handlePromotionSelect(target);
    }
    /**
     * Block: multicolumn-card - Banner media
     */
    if (target.classList.contains("multicolumn-card__image") || target.classList.contains("banner__media") || target.classList.contains("banner__media-image-desktop") || target.classList.contains("banner__media-image-mobile") || target.classList.contains("banner__content") || target.classList.contains("banner__media media mobile") || target.classList.contains("slideshow__text")) {
      GAHelpers.handlePromotionSelect(target);
    }
    /**
     * Block: timer-discount
     */
    if (target.classList.contains("timer-discount-img")) {
      GAHelpers.handlePromotionSelect(target.parentNode.parentNode);
    }
    /**
     * Block: Collection list
     */
    if (target.classList.contains("collection-card-image")) {
      GAHelpers.handleSelectContent(target.parentNode);
    }
    /**
     * Block: Tab content - Menu link
     */
    if (target.classList.contains("tab-title") || target.classList.contains("list-menu__item-link")) {
      GAHelpers.handleSelectContent(target);
    }
    /**
     * Block Tab content product
     */
    if (target.classList.contains("tab-content-item__image")) {
      GAHelpers.handleSelectItem(target.parentNode)
    }

    /**
     * Block Section: Bar devoluciones
     */
    if (target.classList.contains("linkDevo")) {
      GAHelpers.handlePromotionSelect(target);
    }
    /**
     * 
     */
    /**
     * Block Section: Sección banner Asados
     */
    if (target.classList.contains("section-banner-asados-image")) {
      GAHelpers.handlePromotionSelect(item, true);
    }
    /**
     * 
     */


    if (target.classList.contains("full-unstyled-link")) {
      if (target.closest("li").classList.contains("featured-collection")) {
        GAHelpers.handleSelectItem(target.closest("li"))
      }
      if (target.closest("li").classList.contains("blog__post") || target.closest("li").classList.contains("collection-list__item")) {
        GAHelpers.handleSelectContent(target.closest("li"))
      }
      if (target.classList.contains("subheader__product")) {
        GAHelpers.handleSelectContent(target)
      }
    }

    if (target.classList.contains("product-form__submit")) {
      const handle = target.getAttribute("data-handle");
      const variantId = target.getAttribute("data-variant-id");
      const product = await Shopify.analytics.publish('handleProductDataByHandle', {
        handle: handle,
        variantId: parseInt(variantId)
      });
      // Shopify.analytics.publish("add_to_cart_custom", product);
    }

  }
  /**
   * Events By URL
   */
  if (bodyContainer.classList.contains("product")) {
    const handle = bodyContainer.getAttribute("data-handle");
    const variantId = bodyContainer.getAttribute("data-variant-id");
    const product = await Shopify.analytics.publish('handleProductDataByHandle', {
      handle: handle,
      variantId: parseInt(variantId)
    });
    // Shopify.analytics.publish("view_item_custom", product);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains("banner-bottom") || entry.target.classList.contains("multicolumn-section") || entry.target.classList.contains("timer-discount-section") || entry.target.classList.contains("image-banner-section") || entry.target.classList.contains("slideshow")) {
          entry.target.querySelectorAll(".grid__item").forEach(item => {
            GAHelpers.handlePromotionSelect(item, true);
            observer.unobserve(entry.target);
          })
        }
        if (entry.target.classList.contains("sectionBannersAsados")) {
          entry.target.querySelectorAll(".itemBannerAsados").forEach(item => {
            GAHelpers.handlePromotionSelect(item, true);
            observer.unobserve(entry.target);
          })
        }
        if (entry.target.classList.contains("bar")) {
          let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
          entry.target.querySelectorAll(`.bar_devoluciones${isMobile ? '.mobile' : '.desktop'}`).forEach(item => {
            GAHelpers.handlePromotionSelect(item, true);
            observer.unobserve(entry.target);
          })
        }
        if (entry.target.classList.contains("feature-collection-section")) {
          let productList = [];
          entry.target.querySelectorAll(".grid__item").forEach(async item => {
            const handle = item.getAttribute("data-handle");
            const variantId = item.getAttribute("data-variant-id");
            const index = item.getAttribute("data-index");
            const product = await GAHelpers.handleProductDataByHandle(handle, parseInt(variantId), index, true);
            productList.push(product);
          });

          setTimeout(() => {
            GAHelpers.dispatchDatalayer("view_item_list", { item_list_id: entry.target.querySelector(".product-grid").getAttribute("data-list-id"), item_list_name: entry.target.querySelector(".product-grid").getAttribute("data-list-name"), items: productList })
            observer.unobserve(entry.target);
          }, 1000)
        }
      }
    })
  });

  const sections = document.querySelectorAll("section");

  sections.forEach((section) => {
    observer.observe(section);
  });

})